//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type Editor } from "ckeditor5";

export default class PreviewCommand extends Command {
  public constructor(editor: Editor) {
    super(editor);
    this.set("isEnabled", true);
    this.set("value", false);
  }

  execute() {
    this.set("value", !this.value);
  }
}
